var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popup-inner modal-form-community" },
    [
      _c("div", {
        staticClass: "popup-inner__close-popup",
        on: {
          click: function($event) {
            return _vm.closeModal()
          }
        }
      }),
      _c("div", { staticClass: "wrap" }, [
        _c("div", { staticClass: "el el--p_r_md-till-xl" }, [
          _c(
            "h3",
            {
              staticClass:
                "ds-caption ds-caption--size_30xl-md ds-caption--size_lg ds-caption--w_r ds-caption--c_white ds-caption--h_130 ds-caption--upp"
            },
            [_vm._v(_vm._s(_vm.trans.titleRadio))]
          )
        ]),
        _c("div", { staticClass: "el el--p_t_lg-md el--p_t_md" }, [
          _c(
            "div",
            { staticClass: "g-row" },
            _vm._l(_vm.listSelect, function(item, index) {
              return _c(
                "div",
                {
                  staticClass:
                    "g-cols g-cols--12 g-cols--6-sm g-cols--4-lg g-cell"
                },
                [
                  _c("div", { staticClass: "el radio-topic" }, [
                    _c("div", { staticClass: "custom-radio" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.topic,
                              expression: "formData.topic"
                            }
                          ],
                          ref: "child",
                          refInFor: true,
                          attrs: {
                            type: "radio",
                            name: "topic",
                            id: "topic" + index
                          },
                          domProps: {
                            value: item,
                            checked: _vm._q(_vm.formData.topic, item)
                          },
                          on: {
                            change: [
                              function($event) {
                                return _vm.$set(_vm.formData, "topic", item)
                              },
                              function($event) {
                                return _vm.sendDataForm()
                              }
                            ]
                          }
                        }),
                        _c("div", { staticClass: "custom-radio__label" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(_vm._s(item))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._t("content")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48c790e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c790e1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/Modals/ModalTopic.vue
// module id = 100
// module chunks = 0